import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { commonActions } from 'srcReact/components'
import { withTranslation, useTranslation } from 'react-i18next'
import Button from 'srcReact/components/common2/Button'
import { TextBox } from 'srcReact/components/common2/TextBox'
import Icon from 'srcReact/components/icons/Icon'

import Popup from 'reactjs-popup'
import config from 'config'

import styles from './styles.module.scss'
import ImageCropper from 'srcReact/components/common2/ImageCropper'
import PronounPopup from 'srcReact/components/popinsContent/PronounPopup'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import Spinner from 'srcReact/components/common2/Spinner'
import Dropdown1 from 'srcReact/components/common2/Dropdown1'

const ProfileEdition = ({
  isMobile,
  fileCreation,
  fileCreationRemove,
  updateStep,
  previousStep,
  setPreviousStep,
  goToPreviousStep,
  formState,
  setFormState,
  ssoUser
}) => {
  const { t } = useTranslation()
  const [imagePath, setImagePath] = useState(formState.profilePicturePath)
  const [imageId, setImageId] = useState(formState.profilePictureId)
  const [firstName, setFirstName] = useState({ value: formState.firstName })
  const [lastName, setLastName] = useState({ value: formState.lastName })
  const [isPublic, setIsPublic] = useState(formState.is_public)
  const [selectedPronoun, setSelectedPronoun] = useState(
    formState.preferred_pronoun && formState.preferred_pronoun.value ? formState.preferred_pronoun : null
  )

  const [customPronounFirstPart, setCustomPronounFirstPart] = useState(formState.personalized_pronoun[0])
  const [customPronounSecondPart, setCustomPronounSecondPart] = useState(formState.personalized_pronoun[1])
  const [showError, setShowError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [open, setOpen] = useState(false)

  const [showCropper, setShowCropper] = useState(false)
  const [uploadedFile, setUploadedFile] = useState(null)
  const inputPicture = useRef(null)
  const [cropperError, setCropperError] = useState('')
  const [pictureLoader, setPictureLoader] = useState(false)
  const [fromSSO, setFromSSO] = useState(false)
  const [apiSubDomain, setApiSubDomain] = useState('')

  useEffect(() => {
    if (formState?.orgId && formState.orgId > 0 && formState?.organizations?.length > 0) {
      const orgObj = formState.organizations.find((x) => x.id == formState.orgId)
      if (orgObj?.apiSubdomain) {
        setApiSubDomain(orgObj.apiSubdomain)
      }
    }
  }, [])

  useEffect(() => {
    if (fileCreation?.loadingFile) {
      setPictureLoader(true)
    }
    if (fileCreation?.files?.length > 0 && fileCreation?.files[0]?.url) {
      setPictureLoader(false)
      setImagePath(fileCreation.files[0].url)
      setImageId(fileCreation.files[0].id)
    } else {
      setImagePath('')
      setImageId('')
    }
  }, [fileCreation])

  useEffect(() => {
    if (ssoUser) {
      setFromSSO(true)
      setFirstName({ ...firstName, value: ssoUser.firstname })
      setLastName({ ...lastName, value: ssoUser.lastname })
    }
  }, [ssoUser])

  const closeModal = () => {
    setOpen(false)
  }

  const selectFile = async (e) => {
    const file = e.target.files[0]
    setUploadedFile(file)
    setShowCropper(true)
    setCropperError(false)
  }

  const handleChangeFirstName = (e) => {
    if (e && e.target) {
      const { value } = e.target
      setFirstName({
        ...firstName,
        value: value,
        hasError: false,
        errorMessage: ''
      })
    }
  }

  const handleChangeLastName = (e) => {
    setLastName({ ...lastName, hasError: false, errorMessage: '' })

    if (e && e.target) {
      const { value } = e.target
      setLastName({
        ...lastName,
        value: value,
        hasError: false,
        errorMessage: ''
      })
    }
  }

  const handleImageCropperError = (error) => {
    setShowCropper(false)
    setCropperError(error)
  }

  const validateNoun = (noun) => /^[\w'\-,.][^0-9_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]{2,}$/.test(noun)
  const [pronounOptions] = useState([
    { label: t('signup.profile_edition.he_him'), value: 'he' },
    { label: t('signup.profile_edition.she_her'), value: 'she' },
    { label: t('signup.profile_edition.they_them'), value: 'they' },
    {
      label: `${t('signup.profile_edition.other')} ${
        customPronounFirstPart && `(${customPronounFirstPart} / ${customPronounSecondPart})`
      }`,
      value: 'other'
      // callback: () => setOpen(true)
    }
  ])

  const validate = () => {
    const allValuesForVerification = [imagePath, firstName.value, lastName.value].filter((e) => !!e)
    let hasError = false
    if (allValuesForVerification.length !== 4) {
      setShowError(true)

      if (!firstName.value) {
        setFirstName({ ...firstName, hasError: true, errorMessage: t('signup.profile_edition.error_msg_1') })
        hasError = true
      } else if (!validateNoun(firstName.value)) {
        setFirstName({ ...firstName, hasError: true, errorMessage: t('signup.profile_edition.error_msg_3') })
        hasError = true
      }
      if (!lastName.value) {
        setLastName({ ...lastName, hasError: true, errorMessage: t('signup.profile_edition.error_msg_2') })
        hasError = true
      } else if (!validateNoun(lastName.value)) {
        setLastName({ ...lastName, hasError: true, errorMessage: t('signup.profile_edition.error_msg_4') })
        hasError = true
      }
      if (hasError) {
        return false
      }
    }
    setShowError(false)
    return true
  }

  const clickPhoto = () => {
    if (inputPicture?.current) {
      inputPicture.current.click()
    }
  }

  const handlePictureRemove = () => {
    fileCreationRemove()
  }

  const handleSkip = () => {
    setShowCropper(false)
  }

  const setOtherPronoun = () => {
    if (customPronounFirstPart && customPronounSecondPart) {
      setSelectedPronoun({
        label: `${t('signup.profile_edition.other')} ${
          customPronounFirstPart && `(${customPronounFirstPart} / ${customPronounSecondPart})`
        }`,
        value: 'other'
      })
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.container1}>
        {cropperError && (
          <div role='alert' className={styles.errorProfileEdition}>
            {cropperError}
          </div>
        )}
        {pictureLoader && <Spinner />}
        {showCropper ? (
          <ImageCropper
            buttonWrapperSize='medium'
            buttonWrapperCSS={styles.cropActionButtons}
            containerCSS={styles.cropperContainer}
            handleSkip={handleSkip}
            aspectRatio={1}
            hasRoundShape={true}
            showNextButton={false}
            isLoggedIn={0}
            skipText={t('global.cancel')}
            showUploadZone={false}
            externallyUploadedFile={uploadedFile}
            handleError={handleImageCropperError}
            apiSubDomainData={{ organization_id: formState.orgId, apiSubDomain }}
            // cropSize={{
            //   width: appConstantSettings.PROFILE_PIC_MIN_SIZE,
            //   height: appConstantSettings.PROFILE_PIC_MIN_SIZE
            // }}
          />
        ) : imagePath ? (
          <div className={styles.imgContainer}>
            <img src={imagePath} alt={''} className={styles.image} onClick={clickPhoto} />
            <div className={styles.closeIcon} onClick={handlePictureRemove}>
              <Icon name='close' size='small' />
            </div>
          </div>
        ) : (
          <React.Fragment>
            <div className={`${styles.image} ${styles.emptyImage}`} onClick={clickPhoto}></div>
            <button className={styles.addPictureText} onClick={clickPhoto}>
              {t('my_profile.info_block_edit.picture.cta')}
              <input
                id='fileInput'
                ref={inputPicture}
                style={{ display: 'none' }}
                type='file'
                onChange={selectFile}
                accept={appConstantSettings.CROPPER_ACCEPTED_IMAGE_TYPES}
              />
            </button>
          </React.Fragment>
        )}
        {/* <div>
          <label htmlFor='fileInput' className={styles.addPictureText}>
            Add a profile picture
          </label>
          <input id='fileInput' ref={inputPicture} style={{ display: 'none' }} type='file' onChange={selectFile} />
        </div> */}
        <div className={styles.nameInputs}>
          <TextBox
            label={t('signup.profile_edition.first_name_pl')}
            customWrapperCss={styles.textBoxCommon}
            fieldInfo={firstName}
            placeholder={t('signup.profile_edition.first_name_pl')}
            onChange={handleChangeFirstName}
            onBlur={() => null}
            isRequired={true}
            options={{ readOnly: fromSSO }}
          />
          <TextBox
            label={t('signup.profile_edition.last_name_pl')}
            customWrapperCss={`${styles.textBoxCommon} ${styles.lastName}`}
            fieldInfo={lastName}
            placeholder={t('signup.profile_edition.last_name_pl')}
            onChange={handleChangeLastName}
            onBlur={() => null}
            isRequired={true}
            options={{ readOnly: fromSSO }}
          />
        </div>
        <div className={styles.container2}>
          <div className={styles.dropdownContainer}>
            <Dropdown1
              options={pronounOptions}
              className={styles.dropdownSelectedItem}
              onChange={(e) => {
                setSelectedPronoun(e)
                if (e.value !== 'other') {
                  setCustomPronounFirstPart('')
                  setCustomPronounSecondPart('')
                } else {
                  setOpen(true)
                }
              }}
              value={selectedPronoun}
              placeholder={t('signup.profile_edition.pronoun')}
            />
          </div>
          {/* <div className={styles.container3}>
            <div className={styles.publicText}>{t('signup.profile_edition.public')}</div>
            <ToggleSwitch isChecked={isPublic} onChange={(e) => setIsPublic(e)} />
          </div> */}
        </div>
      </div>
      {/* {showError && <div className={styles.errorProfileEdition}>{errorMessage}</div>} */}

      <div className={styles.buttonContainer}>
        <Button
          text={t('signup.profile_edition.back')}
          size='large'
          style='secondary'
          handleClick={fromSSO ? () => updateStep('terms') : goToPreviousStep}
        />
        <Button
          text={t('signup.profile_edition.confirm')}
          size='large'
          customStyle={styles.confirmButton}
          handleClick={() => {
            if (validate()) {
              setOpen(false)
              setPreviousStep([...previousStep, 'profileEdition'])
              updateStep('information')
              setFormState({
                ...formState,
                profilePicturePath: imagePath,
                profilePictureId: imageId,
                firstName: firstName.value,
                lastName: lastName.value,
                is_public: isPublic,
                preferred_pronoun: selectedPronoun,
                personalized_pronoun: [customPronounFirstPart, customPronounSecondPart],
                apiSubDomain: apiSubDomain
              })
            }
          }}
        />
      </div>
      <Popup
        contentStyle={{
          borderRadius: '1.3rem',
          // width: isMobile ? '100%' : 'fit-content',
          width: 'fit-content'
          // padding: isMobile ? '0 2rem' : '0 3rem',
        }}
        open={open}
        closeOnDocumentClick
        onClose={closeModal}>
        <PronounPopup
          closeModal={closeModal}
          customPronounFirst={customPronounFirstPart}
          customPronounSecond={customPronounSecondPart}
          setCustomPronounFirst={setCustomPronounFirstPart}
          setCustomPronounSecond={setCustomPronounSecondPart}
          setOtherPronoun={setOtherPronoun}
        />
      </Popup>
    </div>
  )
}

function mapStateToProps(state) {
  const {
    authentication: { ssoUser },
    common: { isMobile, fileCreation }
  } = state
  return { isMobile, fileCreation, ssoUser }
}

const actionCreators = {
  fileCreationRemove: commonActions.fileCreationRemove
}

const ExtendedComponent = withTranslation('common')(ProfileEdition)

const connectedProfileEdition = connect(mapStateToProps, actionCreators)(ExtendedComponent)
export { connectedProfileEdition as ProfileEdition }
